import { render, staticRenderFns } from "./PressRelease-12-08-2021.vue?vue&type=template&id=02b234d6&scoped=true"
import script from "./PressRelease-12-08-2021.vue?vue&type=script&lang=js"
export * from "./PressRelease-12-08-2021.vue?vue&type=script&lang=js"
import style0 from "./PressRelease-12-08-2021.vue?vue&type=style&index=0&id=02b234d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b234d6",
  null
  
)

export default component.exports